const config = {
  API_URL: process.env.REACT_APP_API_URL,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  SECRET_KEY: process.env.REACT_APP_SECRET_KEY,
  EDITOR_KEY: process.env.REACT_APP_EDITOR_KEY,
};

export default config;
